// 260714nrai: docu-window warning → message lead modal (multi-lead picker)
// 260805nrai: exception/window date pickers; success via toast instead of alert

function currentJournalInstitutionId() {
  const fromClient = window.extractInstitutionId
    ? window.extractInstitutionId($('#record_client_id').val())
    : null;
  if (fromClient) {
    return String(fromClient);
  }

  const institutionId = $('#record_institution_id').val() || $('#current_institution_for_time_records').val();
  return institutionId ? String(institutionId) : '';
}

function docuWindowLeadRequestPayload() {
  return {
    institution_id: currentJournalInstitutionId(),
    von: $('#record_von').val(),
    bis: $('#record_bis').val()
  };
}

function populateDocuWindowLeadSelect(leads, selectedEmployeeId) {
  const $select = $('#docu_window_lead_request_lead_select');
  const $receiver = $('#docu_window_lead_request_receiver');
  $select.empty();

  (leads || []).forEach((lead) => {
    const option = $('<option></option>')
      .val(String(lead.employee_id))
      .text(lead.receiver_name || '');
    $select.append(option);
  });

  const selectedId = selectedEmployeeId || (leads && leads.length ? leads[0].employee_id : null);
  if (selectedId) {
    $select.val(String(selectedId));
  }

  const showPicker = (leads || []).length > 1;
  if (showPicker) {
    $receiver.hide().text('');
    $select.show();
  } else {
    const singleLead = (leads || [])[0];
    $receiver.text(singleLead ? (singleLead.receiver_name || '') : '').show();
    $select.hide();
  }

  $('#docu_window_lead_request_lead_employee_id').val($select.val() || (selectedId ? String(selectedId) : ''));
}

function showDocuWindowLeadRequestToast(message, kind) {
  if (window.toast_manager && typeof window.toast_manager.push_many === 'function') {
    window.toast_manager.push_many([{
      kind: kind || 'success',
      html: message,
      duration_ms: 5000
    }]);
    return;
  }
  // fallback if toast_manager not yet initialized
  const $zone = $('#flash_zone');
  if ($zone.length) {
    $zone.html(`<div class="flash ${kind === 'error' ? 'error' : 'notice'}">${message}</div>`);
  }
}

// 260805nrai: keep subject aligned with chosen exception date; Begründung stays user-filled
function syncDocuWindowLeadRequestMessageText() {
  const exceptionUntil = ($('#docu_window_lead_request_exception_until').val() || '').trim();
  const requesterName = ($('#docu_window_lead_request_modal').data('requesterName') || '—').toString();
  if (!exceptionUntil) {
    return;
  }
  $('#docu_window_lead_request_subject').val(`Freigabe Dokuzeitraum für ${requesterName}: ${exceptionUntil}`);
}

function docuWindowLeadRequestFieldsValid() {
  const subject = ($('#docu_window_lead_request_subject').val() || '').trim();
  const begruendung = ($('#docu_window_lead_request_body').val() || '').trim();
  if (subject && begruendung) {
    $('#docu_window_lead_request_error').hide().text('');
    return true;
  }
  const missing = [];
  if (!subject) {
    missing.push('Betreff');
  }
  if (!begruendung) {
    missing.push('Begründung');
  }
  $('#docu_window_lead_request_error')
    .text(`Es fehlen notwendige Angaben: ${missing.join(', ')}.`)
    .show();
  return false;
}

function openDocuWindowLeadRequestModal(institutionId) {
  const modal = $('#docu_window_lead_request_modal');
  const resolvedInstitutionId = institutionId || currentJournalInstitutionId();
  if (!modal.length || !resolvedInstitutionId) {
    return;
  }

  const payload = docuWindowLeadRequestPayload();
  payload.institution_id = resolvedInstitutionId;

  $('#docu_window_lead_request_error').hide().text('');
  $('#docu_window_lead_request_send').addClass('disabled');

  $.post('/time_records/docu_window_lead_request_form', payload)
    .done((data) => {
      populateDocuWindowLeadSelect(data.leads || [], data.lead_employee_id);
      modal.data('requesterName', data.requester_name || '—');
      $('#docu_window_lead_request_exception_until').val(data.exception_until || '');
      $('#docu_window_lead_request_window_until').val(data.window_until || '');
      $('#docu_window_lead_request_subject').val(data.subject || '');
      $('#docu_window_lead_request_body').val(data.body || '');
      $('#docu_window_lead_request_institution_id').val(data.institution_id || resolvedInstitutionId);
      if (typeof init_datetimepicker === 'function') {
        $('#docu_window_lead_request_exception_until, #docu_window_lead_request_window_until').removeClass('xdinit');
        init_datetimepicker();
      }
      $('#docu_window_lead_request_send').removeClass('disabled');
      modal.foundation('reveal', 'open');
      setTimeout(function () {
        $('#docu_window_lead_request_body').trigger('focus');
      }, 200);
    })
    .fail(() => {
      showDocuWindowLeadRequestToast('Die Anfrage an Ihre Leitung konnte nicht geöffnet werden.', 'error');
    });
}

function sendDocuWindowLeadRequest() {
  if (!docuWindowLeadRequestFieldsValid()) {
    return;
  }

  const payload = {
    institution_id: $('#docu_window_lead_request_institution_id').val() || currentJournalInstitutionId(),
    lead_employee_id: $('#docu_window_lead_request_lead_employee_id').val() || $('#docu_window_lead_request_lead_select').val(),
    subject: ($('#docu_window_lead_request_subject').val() || '').trim(),
    body: ($('#docu_window_lead_request_body').val() || '').trim(),
    von: $('#record_von').val(),
    bis: $('#record_bis').val(),
    exception_until: $('#docu_window_lead_request_exception_until').val(),
    window_until: $('#docu_window_lead_request_window_until').val()
  };

  $('#docu_window_lead_request_error').hide().text('');
  $('#docu_window_lead_request_send').addClass('disabled');

  $.post('/time_records/docu_window_lead_request_send', payload)
    .done((data) => {
      $('#docu_window_lead_request_modal').foundation('reveal', 'close');
      if (data.message) {
        showDocuWindowLeadRequestToast(data.message, 'success');
      }
    })
    .fail((xhr) => {
      const message = (xhr.responseJSON && xhr.responseJSON.error === 'missing_fields')
        ? 'Betreff und Begründung sind erforderlich.'
        : 'Die Nachricht konnte nicht gesendet werden.';
      $('#docu_window_lead_request_error').text(message).show();
    })
    .always(() => {
      $('#docu_window_lead_request_send').removeClass('disabled');
    });
}

function initDocuWindowLeadRequest() {
  $(document).off('click.docuWindowLeadRequest', '.docu-window-lead-request')
    .on('click.docuWindowLeadRequest', '.docu-window-lead-request', function (event) {
      event.preventDefault();
      const institutionId = $(this).attr('data-institution-id') || currentJournalInstitutionId();
      if (!institutionId) {
        return;
      }
      openDocuWindowLeadRequestModal(institutionId);
    });

  $(document).off('change.docuWindowLeadRequest', '#docu_window_lead_request_lead_select')
    .on('change.docuWindowLeadRequest', '#docu_window_lead_request_lead_select', function () {
      $('#docu_window_lead_request_lead_employee_id').val($(this).val() || '');
    });

  $(document).off('click.docuWindowLeadRequestSend', '#docu_window_lead_request_send')
    .on('click.docuWindowLeadRequestSend', '#docu_window_lead_request_send', function (event) {
      event.preventDefault();
      if ($(this).hasClass('disabled')) {
        return;
      }
      sendDocuWindowLeadRequest();
    });

  $(document).off('click.docuWindowLeadRequestCancel', '.docu_window_lead_request_cancel')
    .on('click.docuWindowLeadRequestCancel', '.docu_window_lead_request_cancel', function (event) {
      event.preventDefault();
      $('#docu_window_lead_request_modal').foundation('reveal', 'close');
    });

  $(document).off('change.docuWindowLeadRequestException', '#docu_window_lead_request_exception_until')
    .on('change.docuWindowLeadRequestException', '#docu_window_lead_request_exception_until', function () {
      syncDocuWindowLeadRequestMessageText();
    });
}

export {
  initDocuWindowLeadRequest,
  openDocuWindowLeadRequestModal,
  sendDocuWindowLeadRequest
};
